import { Skeleton } from "../ui/skeleton";

export function RouteFallback() {
  return (
    <main className="mx-auto min-h-dvh w-full max-w-lg bg-background px-5 pb-24 pt-8" aria-label="页面加载中">
      <Skeleton className="h-7 w-28" />
      <Skeleton className="mt-8 h-36 w-full rounded-2xl" />
      <Skeleton className="mt-4 h-20 w-full rounded-2xl" />
      <span className="sr-only">加载中</span>
    </main>
  );
}
